import React from "react";

const Logout = () => {
  return (
    <div className="dashboard-pages-padding">
      <h1>Logout</h1>
      <p>Are you sure you want to logout!</p>
      <div className="logout-button-section">
        <button className="save-profile-btn">Logout</button>
        <button className="cancel-btn">Cancel</button>
      </div>
    </div>
  );
};

export default Logout;
